import React from 'react'
const authContext = React.createContext()
export default authContext
